/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-search
 * Fiona Search Service
 *
 * The version of the OpenAPI document: 0.2.171
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    PatchSearchRequestBody,
    PatchSectionResponse,
    PatchSectionWithinSearchRequestBody,
    Result,
    Search,
    SearchFilter,
    SearchWithExtras,
    SearchWithRateTable,
    SearchWithRelations,
    SectionSummary,
} from '../models';

export interface SearchesControllerCreateSearchRequest {
    productType?: SearchesControllerCreateSearchProductTypeEnum;
    loanAmount?: number;
    annualIncome?: number;
    loanPurpose?: SearchesControllerCreateSearchLoanPurposeEnum;
    creditRating?: SearchesControllerCreateSearchCreditRatingEnum;
    zipcode?: string;
}

export interface SearchesControllerCreateSearchFromExistingLeadRequest {
    searchWithRateTable?: SearchWithRateTable;
}

export interface SearchesControllerFindSearchRequest {
    id: string;
}

export interface SearchesControllerFindSectionWithinSearchRequest {
    searchId: string;
    sectionId: string;
}

export interface SearchesControllerGetAllSearchesRequest {
    views?: Array<SearchesControllerGetAllSearchesViewsEnum>;
    filter?: SearchFilter;
}

export interface SearchesControllerGetMostRecentRequest {
    id: string;
}

export interface SearchesControllerGetResultsRequest {
    id: string;
}

export interface SearchesControllerGetSearchByIdRequest {
    id: string;
}

export interface SearchesControllerPatchSearchRequest {
    id: string;
    patchSearchRequestBody: PatchSearchRequestBody;
}

export interface SearchesControllerPatchSectionWithinSearchRequest {
    searchId: string;
    sectionId: string;
    patchSectionWithinSearchRequestBody: PatchSectionWithinSearchRequestBody;
}

/**
 * SearchesControllerApi - interface
 * 
 * @export
 * @interface SearchesControllerApiInterface
 */
export interface SearchesControllerApiInterface {
    /**
     * 
     * @param {'credit_card' | 'insurance' | 'life_insurance' | 'loan' | 'mortgage' | 'savings' | 'other'} [productType] 
     * @param {number} [loanAmount] 
     * @param {number} [annualIncome] 
     * @param {'debt_consolidation' | 'credit_card_refi' | 'home_improvement' | 'large_purchases' | 'auto_purchase' | 'auto_refinance' | 'baby' | 'boat' | 'business' | 'car_repair' | 'cosmetic' | 'emergency' | 'engagement' | 'green' | 'home_purchase' | 'home_refi' | 'household_expenses' | 'life_event' | 'medical_dental' | 'motorcycle' | 'moving_relocation' | 'rv' | 'special_occasion' | 'student_loan' | 'student_loan_refi' | 'taxes' | 'vacation' | 'wedding' | 'other'} [loanPurpose] 
     * @param {'excellent' | 'good' | 'fair' | 'poor'} [creditRating] 
     * @param {string} [zipcode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerCreateSearchRaw(requestParameters: SearchesControllerCreateSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchWithRelations>>;

    /**
     */
    searchesControllerCreateSearch(requestParameters: SearchesControllerCreateSearchRequest, initOverrides?: RequestInit): Promise<SearchWithRelations>;

    /**
     * 
     * @param {SearchWithRateTable} [searchWithRateTable] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerCreateSearchFromExistingLeadRaw(requestParameters: SearchesControllerCreateSearchFromExistingLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchWithExtras>>;

    /**
     */
    searchesControllerCreateSearchFromExistingLead(requestParameters: SearchesControllerCreateSearchFromExistingLeadRequest, initOverrides?: RequestInit): Promise<SearchWithExtras>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerFindSearchRaw(requestParameters: SearchesControllerFindSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SectionSummary>>>;

    /**
     */
    searchesControllerFindSearch(requestParameters: SearchesControllerFindSearchRequest, initOverrides?: RequestInit): Promise<Array<SectionSummary>>;

    /**
     * 
     * @param {string} searchId 
     * @param {string} sectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerFindSectionWithinSearchRaw(requestParameters: SearchesControllerFindSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SectionSummary>>;

    /**
     */
    searchesControllerFindSectionWithinSearch(requestParameters: SearchesControllerFindSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<SectionSummary>;

    /**
     * 
     * @param {Array<'data' | 'summary'>} [views] 
     * @param {SearchFilter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerGetAllSearchesRaw(requestParameters: SearchesControllerGetAllSearchesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SearchWithExtras>>>;

    /**
     */
    searchesControllerGetAllSearches(requestParameters: SearchesControllerGetAllSearchesRequest, initOverrides?: RequestInit): Promise<Array<SearchWithExtras>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerGetMostRecentRaw(requestParameters: SearchesControllerGetMostRecentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SectionSummary>>;

    /**
     */
    searchesControllerGetMostRecent(requestParameters: SearchesControllerGetMostRecentRequest, initOverrides?: RequestInit): Promise<SectionSummary>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerGetResultsRaw(requestParameters: SearchesControllerGetResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>>;

    /**
     */
    searchesControllerGetResults(requestParameters: SearchesControllerGetResultsRequest, initOverrides?: RequestInit): Promise<Result>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerGetSearchByIdRaw(requestParameters: SearchesControllerGetSearchByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Search>>;

    /**
     */
    searchesControllerGetSearchById(requestParameters: SearchesControllerGetSearchByIdRequest, initOverrides?: RequestInit): Promise<Search>;

    /**
     * 
     * @param {string} id 
     * @param {PatchSearchRequestBody} patchSearchRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerPatchSearchRaw(requestParameters: SearchesControllerPatchSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Search>>;

    /**
     */
    searchesControllerPatchSearch(requestParameters: SearchesControllerPatchSearchRequest, initOverrides?: RequestInit): Promise<Search>;

    /**
     * 
     * @param {string} searchId 
     * @param {string} sectionId 
     * @param {PatchSectionWithinSearchRequestBody} patchSectionWithinSearchRequestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchesControllerApiInterface
     */
    searchesControllerPatchSectionWithinSearchRaw(requestParameters: SearchesControllerPatchSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PatchSectionResponse>>;

    /**
     */
    searchesControllerPatchSectionWithinSearch(requestParameters: SearchesControllerPatchSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<PatchSectionResponse>;

}

/**
 * 
 */
export class SearchesControllerApi extends runtime.BaseAPI implements SearchesControllerApiInterface {

    /**
     */
    async searchesControllerCreateSearchRaw(requestParameters: SearchesControllerCreateSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchWithRelations>> {
        const queryParameters: any = {};

        if (requestParameters.productType !== undefined) {
            queryParameters['productType'] = requestParameters.productType;
        }

        if (requestParameters.loanAmount !== undefined) {
            queryParameters['loanAmount'] = requestParameters.loanAmount;
        }

        if (requestParameters.annualIncome !== undefined) {
            queryParameters['annualIncome'] = requestParameters.annualIncome;
        }

        if (requestParameters.loanPurpose !== undefined) {
            queryParameters['loanPurpose'] = requestParameters.loanPurpose;
        }

        if (requestParameters.creditRating !== undefined) {
            queryParameters['creditRating'] = requestParameters.creditRating;
        }

        if (requestParameters.zipcode !== undefined) {
            queryParameters['zipcode'] = requestParameters.zipcode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerCreateSearch(requestParameters: SearchesControllerCreateSearchRequest = {}, initOverrides?: RequestInit): Promise<SearchWithRelations> {
        const response = await this.searchesControllerCreateSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerCreateSearchFromExistingLeadRaw(requestParameters: SearchesControllerCreateSearchFromExistingLeadRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SearchWithExtras>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.searchWithRateTable,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerCreateSearchFromExistingLead(requestParameters: SearchesControllerCreateSearchFromExistingLeadRequest = {}, initOverrides?: RequestInit): Promise<SearchWithExtras> {
        const response = await this.searchesControllerCreateSearchFromExistingLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerFindSearchRaw(requestParameters: SearchesControllerFindSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SectionSummary>>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchesControllerFindSearch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{id}/sections`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerFindSearch(requestParameters: SearchesControllerFindSearchRequest, initOverrides?: RequestInit): Promise<Array<SectionSummary>> {
        const response = await this.searchesControllerFindSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerFindSectionWithinSearchRaw(requestParameters: SearchesControllerFindSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SectionSummary>> {
        if (requestParameters.searchId === null || requestParameters.searchId === undefined) {
            throw new runtime.RequiredError('searchId','Required parameter requestParameters.searchId was null or undefined when calling searchesControllerFindSectionWithinSearch.');
        }

        if (requestParameters.sectionId === null || requestParameters.sectionId === undefined) {
            throw new runtime.RequiredError('sectionId','Required parameter requestParameters.sectionId was null or undefined when calling searchesControllerFindSectionWithinSearch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{searchId}/sections/{sectionId}`.replace(`{${"searchId"}}`, encodeURIComponent(String(requestParameters.searchId))).replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters.sectionId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerFindSectionWithinSearch(requestParameters: SearchesControllerFindSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<SectionSummary> {
        const response = await this.searchesControllerFindSectionWithinSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerGetAllSearchesRaw(requestParameters: SearchesControllerGetAllSearchesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<SearchWithExtras>>> {
        const queryParameters: any = {};

        if (requestParameters.views) {
            queryParameters['views'] = requestParameters.views;
        }

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerGetAllSearches(requestParameters: SearchesControllerGetAllSearchesRequest = {}, initOverrides?: RequestInit): Promise<Array<SearchWithExtras>> {
        const response = await this.searchesControllerGetAllSearchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerGetMostRecentRaw(requestParameters: SearchesControllerGetMostRecentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<SectionSummary>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchesControllerGetMostRecent.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{id}/sections/current`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerGetMostRecent(requestParameters: SearchesControllerGetMostRecentRequest, initOverrides?: RequestInit): Promise<SectionSummary> {
        const response = await this.searchesControllerGetMostRecentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerGetResultsRaw(requestParameters: SearchesControllerGetResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchesControllerGetResults.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{id}/results`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerGetResults(requestParameters: SearchesControllerGetResultsRequest, initOverrides?: RequestInit): Promise<Result> {
        const response = await this.searchesControllerGetResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerGetSearchByIdRaw(requestParameters: SearchesControllerGetSearchByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Search>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchesControllerGetSearchById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerGetSearchById(requestParameters: SearchesControllerGetSearchByIdRequest, initOverrides?: RequestInit): Promise<Search> {
        const response = await this.searchesControllerGetSearchByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerPatchSearchRaw(requestParameters: SearchesControllerPatchSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Search>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling searchesControllerPatchSearch.');
        }

        if (requestParameters.patchSearchRequestBody === null || requestParameters.patchSearchRequestBody === undefined) {
            throw new runtime.RequiredError('patchSearchRequestBody','Required parameter requestParameters.patchSearchRequestBody was null or undefined when calling searchesControllerPatchSearch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchSearchRequestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerPatchSearch(requestParameters: SearchesControllerPatchSearchRequest, initOverrides?: RequestInit): Promise<Search> {
        const response = await this.searchesControllerPatchSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async searchesControllerPatchSectionWithinSearchRaw(requestParameters: SearchesControllerPatchSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<PatchSectionResponse>> {
        if (requestParameters.searchId === null || requestParameters.searchId === undefined) {
            throw new runtime.RequiredError('searchId','Required parameter requestParameters.searchId was null or undefined when calling searchesControllerPatchSectionWithinSearch.');
        }

        if (requestParameters.sectionId === null || requestParameters.sectionId === undefined) {
            throw new runtime.RequiredError('sectionId','Required parameter requestParameters.sectionId was null or undefined when calling searchesControllerPatchSectionWithinSearch.');
        }

        if (requestParameters.patchSectionWithinSearchRequestBody === null || requestParameters.patchSectionWithinSearchRequestBody === undefined) {
            throw new runtime.RequiredError('patchSectionWithinSearchRequestBody','Required parameter requestParameters.patchSectionWithinSearchRequestBody was null or undefined when calling searchesControllerPatchSectionWithinSearch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/searches/{searchId}/sections/{sectionId}`.replace(`{${"searchId"}}`, encodeURIComponent(String(requestParameters.searchId))).replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters.sectionId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchSectionWithinSearchRequestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async searchesControllerPatchSectionWithinSearch(requestParameters: SearchesControllerPatchSectionWithinSearchRequest, initOverrides?: RequestInit): Promise<PatchSectionResponse> {
        const response = await this.searchesControllerPatchSectionWithinSearchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export type SearchesControllerCreateSearchProductTypeEnum = 'credit_card' |'insurance' |'life_insurance' |'loan' |'mortgage' |'savings' |'other' 
/**
    * @export
    * @enum {string}
    */
export type SearchesControllerCreateSearchLoanPurposeEnum = 'debt_consolidation' |'credit_card_refi' |'home_improvement' |'large_purchases' |'auto_purchase' |'auto_refinance' |'baby' |'boat' |'business' |'car_repair' |'cosmetic' |'emergency' |'engagement' |'green' |'home_purchase' |'home_refi' |'household_expenses' |'life_event' |'medical_dental' |'motorcycle' |'moving_relocation' |'rv' |'special_occasion' |'student_loan' |'student_loan_refi' |'taxes' |'vacation' |'wedding' |'other' 
/**
    * @export
    * @enum {string}
    */
export type SearchesControllerCreateSearchCreditRatingEnum = 'excellent' |'good' |'fair' |'poor' 
/**
    * @export
    * @enum {string}
    */
export type SearchesControllerGetAllSearchesViewsEnum = 'data' |'summary' 
